import React from 'react';

export type ListInlineItemMockProps = {
  children: JSX.Element | JSX.Element[];
  lineBreak?: boolean;
};

export const ListInlineValueMock = ({ children: _children, lineBreak = true }: ListInlineItemMockProps) => {
  const children = Array.isArray(_children) ? _children : [_children];
  const valuesLength = children?.length;
  const lineBreakEl = (i: number) => lineBreak && i < valuesLength && <br />;
  if (valuesLength) {
    return (
      <span className="u-text-sm u-textSemibold u-textRight">
        {children.map((child, i) => (
          <React.Fragment key={i}>
            {child}
            {lineBreakEl(i)}
          </React.Fragment>
        ))}
      </span>
    );
  }
  return null;
};

export type ListInlineItemProps = {
  value?: React.ReactNode;
  classes?: string;
  valueSecondary?: React.ReactNode;
  classesSecondary?: string;
  lineBreak?: boolean;
};

export const ListInlineValue = ({
  value,
  classes,
  valueSecondary,
  classesSecondary,
  lineBreak = true,
}: ListInlineItemProps) => {
  if (valueSecondary) {
    return (
      <span className="u-text-sm u-textSemibold u-textRight">
        <span className={classes}>{value}</span>
        {lineBreak && <br />}
        <span className={classesSecondary}>{valueSecondary}</span>
      </span>
    );
  }
  return (
    <span className="u-text-sm u-textSemibold u-textRight">
      <span className={classes}>{value}</span>
    </span>
  );
};
